var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFadeStaggerCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    r: 15,
    cx: 40,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 1,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    r: 15,
    cx: 100,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 1,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    r: 15,
    cx: 160,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 1,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadeStaggerCircles);
export default __webpack_public_path__ + "static/media/fade-stagger-circles.62581d332c85a7bb74507013b932e3e0.svg";
export { ForwardRef as ReactComponent };